export const FETCH_SOFTWARE_INIT = 'FETCH_SOFTWARE_INIT';
export const FETCH_SOFTWARE_DONE = 'FETCH_SOFTWARE_DONE';
export const FETCH_SOFTWARE_FAIL = 'FETCH_SOFTWARE_FAIL';
export const FETCH_MODAL_CONTENT_INIT = 'FETCH_MODAL_CONTENT_INIT';
export const FETCH_MODAL_CONTENT_DONE = 'FETCH_MODAL_CONTENT_DONE';
export const FETCH_MODAL_CONTENT_FAIL = 'FETCH_MODAL_CONTENT_FAIL';
export const ACCEPT_EULA_INIT = 'ACCEPT_EULA_INIT';
export const ACCEPT_EULA_DONE = 'ACCEPT_EULA_DONE';
export const ACCEPT_EULA_FAIL = 'ACCEPT_EULA_FAIL';
